import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  // withCredentials: true // Not sure this is needed yet
});

export default api;
